import React from 'react';
import styles from './label.module.scss';
import cx from 'classnames';

type Props = {
  size?: 'xs' | 'sm' | 'md' | 'lg';
  color?: 'black' | 'grey' | 'error' | 'white';
  bold?: boolean;
  children: any;
  className?: string;
};

const Label = (props: Props) => {
  const { size = 'md', color = 'black', bold = false, children, className } = props;

  const labelStyle = cx(styles.Label, styles[color], styles[size], { [styles.bold]: bold }, className);

  return (
    <div className={labelStyle} aria-label={children}>
      {children}
    </div>
  );
};

export default Label;
